import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupExclude: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-exclude"><path fillRule="evenodd" clipRule="evenodd" d="M16 16H18C20.2091 16 22 14.2091 22 12V6C22 3.79086 20.2091 2 18 2H12C9.79086 2 8 3.79086 8 6V8H6C3.79086 8 2 9.79086 2 12V18C2 20.2091 3.79086 22 6 22H12C14.2091 22 16 20.2091 16 18V16ZM8 8H12C14.2091 8 16 9.79086 16 12V16H12C9.79086 16 8 14.2091 8 12V8Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBooleanGroupExclude;
